import React from 'react'
import PolicyBalance from '../../../features/payments/components/history/GetPolicyDisplay'

const CustomerDashboard = () => {
    return (
        <div className="min-h-screen bg-base-200 pt-28 pb-8">
            <div className="container mx-auto px-4 max-w-7xl">
                <PolicyBalance />
            </div>
        </div>
    );
};

export default CustomerDashboard;